import {
  Box,
  Button,
  RoundedBox,
  Typography,
} from "@braintrust/braintrust-ui-components";
import {
  BraintrustIcon,
  BYOTIcon,
  TransferIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { ArrowLeftIcon } from "@braintrust/braintrust-ui-components/Icons";
import { Errors } from "@js/apps/byot/components/errors";
import { ImpersonatedEmail } from "@js/apps/byot/components/impersonated-email";
import { UploadBYOTCsv } from "@js/apps/byot/components/importer";
import {
  MessageModalContent,
  MessageModalInstance,
  openMessageModalInstance,
} from "@js/apps/byot/components/message-modal/";
import { UploadedFileBadge } from "@js/apps/byot/components/uploaded-file-badge";
import { useUploadBYOTCsv } from "@js/apps/byot/hooks/upload-byot-csv";
import { useGoBackHistory } from "@js/hooks/go-back-history";
import { FullPageWithStickyHeaderLayout } from "@js/layouts/full-page-with-sticky-header";

import style from "./style.module.scss";

export const BYOTClientMVPPage = () => {
  const {
    onSubmit,
    control,
    isSubmitting,
    dispatch,
    error,
    isProcessing,
    fileName,
    isProcessedSuccessfully,
    disableSendOffersButton,
    numberOfOffers,
  } = useUploadBYOTCsv();

  return (
    <form onSubmit={onSubmit}>
      <FullPageWithStickyHeaderLayout
        pageTitle="BYOT"
        header={
          <div className={style.headerContent}>
            <Box sx={{ ml: -2 }}>
              <BackButton />
            </Box>
            <Button
              variant="primary"
              size="medium"
              shape="squared"
              onClick={openMessageModalInstance}
              disabled={disableSendOffersButton}
            >
              Send offers
            </Button>
          </div>
        }
        content={
          <RoundedBox className={style.content}>
            <Header />
            <Box component="main" sx={{ mt: "24px" }}>
              {isProcessedSuccessfully ? (
                <>
                  <Typography component="p" variant="label" sx={{ mb: 1 }}>
                    Import summary
                  </Typography>
                  <UploadedFileBadge fileName={fileName || ""} />
                  <Typography
                    component="p"
                    variant="label"
                    size="small"
                    sx={{ mt: 3 }}
                  >
                    {numberOfOffers} Talent imported
                  </Typography>
                </>
              ) : (
                <>
                  <UploadBYOTCsv
                    isProcessingData={isProcessing}
                    onBeforeUpload={() => {
                      dispatch({ type: "start_processing" });
                    }}
                    onUpload={(uploadedFile) => {
                      dispatch({ type: "uploaded", payload: uploadedFile });
                    }}
                    onUploadError={(uploadError) => {
                      dispatch({
                        type: "uploaded_with_error",
                        payload: uploadError,
                      });
                    }}
                  />
                  {!!error && (
                    <Box sx={{ display: "inline-block" }}>
                      <Errors error={error} />
                    </Box>
                  )}
                </>
              )}
            </Box>
          </RoundedBox>
        }
      />
      <MessageModalInstance>
        <MessageModalContent
          isSubmitting={isSubmitting}
          control={control}
          numberOfOffers={numberOfOffers}
        />
      </MessageModalInstance>
    </form>
  );
};

const Header = () => {
  return (
    <Box component="header">
      <Box
        sx={{
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <BYOTIcon sx={{ width: 42, height: 42 }} />
        <TransferIcon />
        <BraintrustIcon
          variant="centered"
          data-testid="braintrust-icon"
          sx={{
            color: "var(--white)",
            width: "42px",
            height: "42px",
            padding: "5px",
            background: "var(--black)",
            borderRadius: "50%",
          }}
        />
      </Box>
      <Typography component="h1" variant="title" size="small" fontWeight={400}>
        Bring Your Own Talent
      </Typography>
      <Typography component="h2">
        Add your trusted professionals to the platform.
      </Typography>
      <Typography component="p" sx={{ mt: "32px" }}>
        You are logged in as: <ImpersonatedEmail />.
      </Typography>
    </Box>
  );
};

const BackButton = () => {
  const goBack = useGoBackHistory();

  return (
    <Button
      variant="transparent"
      startIcon={<ArrowLeftIcon />}
      size="medium"
      shape="squared"
      onClick={() => {
        goBack("/employer/dashboard/my_talent");
      }}
    >
      Back
    </Button>
  );
};
